import React, { useState, useEffect, useMemo } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewTransferCompany, existsTransferCompany, updateTransferCompany } from '../../../../slices/transferCompany/thunk';
import { setRequireCloseModal } from '../../../../slices/transferCompany/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import validateRUT from '../../../../helpers/utils/validateRUT';
import OSelect from '../../../../Components/OElements/OSelect';
import { getFinalDestinationList } from '../../../../helpers/residue/backend_helper';
import { Files } from '../../../FileManager/Files';
import { default as LocalFiles } from '../../../FilesLocal/Files';
import useFileType from '../../../../Components/Hooks/useFileTypeHooks';
import { uploadFile } from '../../../../slices/thunks';
import UploadOneFileModal from '../../../FilesLocal/Modal/UploadOneFileModal';
import { getTransferTypeList } from '../../../../helpers/transfer/backend_helper';
import usePathFolder from '../../../../Components/Hooks/usePathFolder';
import useUploadFiles from '../../../../Components/Hooks/useUploadFiles';
import OInput from '../../../../Components/OElements/OInput';


const TransferCompanyForm = ({ dataTransferCompany, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const [disabledCheck, setDisabledCheck] = useState(dataTransferCompany.disable);
	const [isInternalCheck, setIsInternalCheck] = useState(dataTransferCompany.isInternal);
	const [isLoading, setIsLoading] = useState(false);
	const [localFiles, setLocalFiles] = useState([]);
	const [newDocumentId, setNewDocumentId] = useState(null);
	const { file_type } = useFileType('OTR');
	const [modalUploadOneFile, setModalUploadOneFile] = useState(false);

	function handleToggleModalUploadOneFile() {
		setModalUploadOneFile(!modalUploadOneFile);
	}

	const selectorTransferCompany = createSelector(
		state => state.TransferCompanies,
		transferCompany => ({
			isAdding: transferCompany.isAdding,
			isAdded: transferCompany.isAdded,
			isUpdating: transferCompany.isUpdating,
			isUpdated: transferCompany.isUpdated,
			isLoadingList: transferCompany.isLoadingList,
			requireCloseModal: transferCompany.requireCloseModal,
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal, } = useSelector(selectorTransferCompany);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			rut: dataTransferCompany.rut || '',
			name: dataTransferCompany.name || '',
			final_destination_ids: [],
			transfer_type_ids: []
		},
		validationSchema: Yup.object({
			rut: Yup.string()
				.required('Campo requerido')
				.test('valid-rut', 'RUT inválido', value => validateRUT(value))
				.test({
					name: 'rut-exists-check',
					message: 'RUT ya existe',
					test: async function (value) {
						if (!isEdit && value) {
							const exists = await dispatch(existsTransferCompany(value));
							if (exists.payload == true) {
								return this.createError({ message: 'RUT ya existe' });
							}
						}
						return true;
					}
				}),
			name: Yup.string().required('Campo requerido'),
			final_destination_ids: Yup.array().of(Yup.string()).nullable(),
			transfer_type_ids: Yup.array().of(Yup.string())
		}),
		onSubmit: async (values) => {
			setIsLoading(true);
			let dataUploadedFiles = [];

			if (isEdit && !dataTransferCompany?.folder_id || !isEdit) {

				let localFilesToUpload = localFiles.map(localFile => {
					return {
						file_type_id: file_type?._id,
						file: localFile.file
					}
				});
				dataUploadedFiles = await uploadFiles(
					pathFolder,
					{},
					localFilesToUpload
				);
			}

			if (isEdit) {
				const updatedTransferCompany = {
					_id: dataTransferCompany._id,
					rut: values.rut,
					name: values.name,
					disabled: disabledCheck,
					isInternal: isInternalCheck,
					final_destination_ids: values.final_destination_ids,
					transfer_type_ids: values.transfer_type_ids,
					folder_id: (
						dataTransferCompany.folder_id
							? dataTransferCompany.folder_id
							: dataUploadedFiles.folder[0] || null
					),
					document_ids: (
						dataTransferCompany.document_ids
							? dataTransferCompany.document_ids
							: dataUploadedFiles?.files || []
					)
				}
				dispatch(updateTransferCompany(updatedTransferCompany));
			} else {

				const newTransferCompany = {
					rut: values.rut,
					name: values.name,
					disabled: disabledCheck,
					isInternal: isInternalCheck,
					final_destination_ids: values.final_destination_ids,
					transfer_type_ids: values.transfer_type_ids,
					folder_id: dataUploadedFiles.folder[0] || null,
					document_ids: dataUploadedFiles?.files || []
				}
				dispatch(addNewTransferCompany(newTransferCompany));
			}
			dispatch(setRequireCloseModal(false));
		},
	});

	const pathFolder = usePathFolder([
		'Logística',
		validation.values.name,
		'Documentos'
	]);

	const {
		uploadFiles
	} = useUploadFiles();

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={4}>
								<OInput
									name='rut'
									label='RUT'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={4}>
								<OInput
									name='name'
									label='Nombre'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key='transfer_types'
									label='Tipo de Transporte'
									id='transfer_type_ids'
									name='transfer_type_ids'
									value={dataTransferCompany?.transfer_type_ids}
									requestApi={() => getTransferTypeList({})}
									validation={validation}
									isMulti
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key='final_destinations'
									label='Destinos Finales'
									id='final_destination_ids'
									name='final_destination_ids'
									value={dataTransferCompany?.final_destination_ids}
									requestApi={() => getFinalDestinationList({})}
									validation={validation}
									isMulti
								/>
							</Col>
							<Col lg={4}>
								<FormGroup className='d-flex gap-2 align-items-center'>
									<Label className=''>
										<div className='d-flex'>
											<Input
												type="checkbox"
												checked={isInternalCheck}
												onChange={(e) => setIsInternalCheck(e.target.checked)}
											/>
											<div className='px-1'>
												Servicio interno
											</div>
										</div>
									</Label>
									{validation.touched.isInternal &&
										validation.errors.isInternal ? (
										<FormFeedback type='invalid'>
											{validation.errors.isInternal}
										</FormFeedback>
									) : null}
									{isEdit && (
										<React.Fragment>
											<Label className=''>
												<div className='d-flex'>
													<Input
														type="checkbox"
														checked={disabledCheck}
														onChange={(e) => setDisabledCheck(e.target.checked)}
													/>
													<div className='px-1'>
														¿Registro inactivo?
													</div>
												</div>
											</Label>
											{validation.touched.disabled &&
												validation.errors.disabled ? (
												<FormFeedback type='invalid'>
													{validation.errors.disabled}
												</FormFeedback>
											) : null}
										</React.Fragment>
									)}
								</FormGroup>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId={'2'}>
						<Row className='g-3'>
							{
								(isEdit && dataTransferCompany.folder_id ?

									<React.Fragment>
										<UploadOneFileModal
											isOpen={modalUploadOneFile}
											folderId={dataTransferCompany.folder_id}
											fileTypeId={file_type?._id}
											handleToggleModal={handleToggleModalUploadOneFile}
											handleNewDocumentId={setNewDocumentId}
										/>
										<Files
											key={`${newDocumentId}` || ''}
											current_folder={(dataTransferCompany?.folder)}
											has_folders={true}
											handleFile={() => handleToggleModalUploadOneFile()}
										/>
									</React.Fragment>
									:
									<LocalFiles
										localFiles={localFiles}
										handleLocalFiles={setLocalFiles}
										folderId={(
											dataTransferCompany?.folder_id
												? dataTransferCompany?.folder_id :
												null
										)}
										fileTypeId={file_type?._id}
									/>
								)
							}
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isAdding ||
							isUpdating ||
							isLoading
						}
					>
						{
							isAdding ||
								isUpdating ||
								isLoading
								? (
									<i className='label-icon'>
										<Spinner size='sm' />
									</i>
								)
								: <i className='ri-save-3-line label-icon'></i>
						}
						{isEdit ? 'Editar' : 'Crear'} Empresa de Transporte
					</button>
				</div>
			</div>
		</Form>
	);
};

export default TransferCompanyForm;
